export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
export const OTP_CHECK = 'OTP_CHECK';